module.exports = __webpack_public_path__ + "images/pic-close.d65357d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/pic-close.png
// module id = LIVc
// module chunks = 19